


































import EmployeSelect from "../../core/Forms/EmployeSelect.vue";
import PlanningsListDetail from "../EmployePlanningsEditPartials/PlanningsListDetail.vue";
import { EmployeApi } from "../../api/EmployeApi";
import InputField from "../../core/Forms/InputField.vue";

export default {
    name: "PlanningModalSelectCopy",
    components: { InputField, PlanningsListDetail, EmployeSelect },
    data() {
        return {
            selectedEmploye: null,
            plannings: [],
            selectedPlanning: null,
            EmployeApi: new EmployeApi(),
        };
    },
    watch: {
        selectedEmploye: function (newVal, oldVal) {
            let self = this;
            if (newVal) {
                self.EmployeApi.getPlannings(newVal.id).then(function (
                    response
                ) {
                    self.plannings = response;
                    if (response.length > 0) {
                        self.selectedPlanning = response[0];
                    } else {
                        self.selectedPlanning = null;
                    }
                });
            }
        },
        selectedPlanning: {
            immediate: true,
            deep: true,
            handler: function (newVal) {
                let self = this;
                if (newVal) {
                    self.$emit("planning-selected", newVal);
                }
            },
        },
    },
};
